import { IAuthService } from "../authentication/AuthService";

export interface IApiConfig {
  getAuthorization(): Promise<string>;
  getAuthService(): IAuthService;
  getAccessToken(): Promise<string | undefined>;
}

export default class ApiConfig implements IApiConfig {
  private authService: IAuthService;

  constructor(authService: IAuthService) {
    this.authService = authService;
  }

  async getAuthorization(): Promise<string> {
    const token = await this.authService.getAccessToken();
    return token ? `Bearer ${token}` : "";
  }

  async getAccessToken(): Promise<string | undefined> {
    return await this.authService.getAccessToken();
  }

  getAuthService(): IAuthService {
    return this.authService;
  }
}
